const FreeCard = () => {
  return (
    <div>
      
     
    </div>
  );
};

export default FreeCard;
